import { render, staticRenderFns } from "./DispositivosSeriadosDetalles.vue?vue&type=template&id=0681e28f&"
import script from "./DispositivosSeriadosDetalles.vue?vue&type=script&lang=ts&"
export * from "./DispositivosSeriadosDetalles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports